import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/pt';
// import InsightcareFooter from './components/InsightcareFooter';
import AuxRoutines from './AuxRoutines';
//require('moment/locale/pt-BR');
import { BACKEND_URL } from './config/constants';
import Select from 'react-select';

import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import InsightcareHeader from './components/InsightcareHeader';
import ProgressBar from './components/Progress';
import Loading from './components/Loading';
import PdfLaboratorioFast from './components/PdfLaboratorioFast';

class PainelLaboratorioFast extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      loading: true,
      cycle: 0,
      totalCycles: 0,
      numberOfElements: 0,
      pacientes: [],
      searchPacientes: [],
      filteredPacientes: [],
      base: params.base,
      company: params.company,
      locationName: AuxRoutines.getLocationName(params.base, params.company),
      theme: (params.theme === 'dark' ? 'dark' : 'light'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
    // setInterval(this.loadRequiredData, 20000);
    //this.randomize();
  }

  componentDidMount() {
    //Carrega o local se existe
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
    if (this.state.theme === 'dark') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(100).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 10000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }

  actionPause(boolPause) {
    if (boolPause === 0) {
      this.setState({ boolPause: 1 }, () => {
        this.pauseProgress();
      });
    }
    if (boolPause === 1) {
      this.setState({ boolPause: 0 }, () => {
        this.moveProgress();
      });
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 8;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.moveProgress();
        this.setState({ cycle: this.state.totalCycles, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.moveProgress();
        this.setState({ cycle: this.state.cycle - 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.moveProgress();
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

  changeTheme() {
    this.setState({ loading: true });
    this.setState(prevState => ({
      theme: prevState.theme === 'light' ? 'dark' : 'light',
    }));

    var $path = '/painel/laboratorio-fast/' + this.state.base + '/' + this.state.company;

    if (this.state.theme === 'light') {
      $path = $path + '/dark';
    }
    window.location.href = $path;
    setTimeout(() => {
      this.setState({ loading: false });
    }, 300);
  }

  textoGrupoPacientes(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredPacientes.length === 1) {
      return "Mostrando de 1 a 1, de 1 paciente";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 8;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 8;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " pacientes";
    }
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredPacientes.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  async loadRequiredData() {
    let sliceSize = 8;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm | D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }
  }

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
    //console.log(this.state.base)
    let url = 'https://integracao.gruposanta.com.br/command-center/painel-laboratorio-urgencia-fast?base=' + this.state.base;
    if (this.state.company !== undefined && this.state.company !== null) {
      url = url + '&company=' + this.state.company;
    }
    let response = await axios.get(url);
    //console.log(response.data);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ResponseData;
    }

    this.setState({
      searchPacientes: returnData,
      filteredPacientes: this.state.filteredPacientes.length !== 0 ? this.state.filteredPacientes : returnData,
    });

    return returnData;
  }

  render() {
    const loading = this.state.loading;
    const theme = this.state.theme;
    return (
      <div className={"App " + theme}>
        {
          loading
            ? (<Loading />)
            : (
              <div>
                <InsightcareHeader title="Monitoramento PS Laboratório" theme={theme} />
                <main className={"content " + theme} id="panel1Styled">
                  <ProgressBar value={this.state.value} max={100} theme={theme} />
                  <div className={"inforow " + theme}>
                    <div className={'inforow right ' + theme}>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(0)}><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(1)}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.actionPause(this.state.boolPause)}><img src={(this.state.boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + this.state.iconText + ".svg"} alt="" /></button>
                      <div className='infoText'>{this.textoGrupoPacientes(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
                    </div>
                    <div className={'inforow left ' + theme}>
                      <div className='infoText'>Agora são {this.state.currentDateHour}</div>
                      <PdfLaboratorioFast title={"Monitoramento PS Laboratório"} list={(this.state.filteredPacientes.length === 0) ? this.state.searchPacientes : this.state.filteredPacientes} theme={theme} />
                      <form>
                        <div className={'buttonSearch ' + theme}>
                          <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                          <Select className={'selectSearch ' + theme}
                            placeholder="Busque por um paciente..."
                            options={
                              this.state.searchPacientes.map(opt => ({
                                key: opt.CODIGOATENDIMENTO,
                                label: opt.NOMEPACIENTE.split(' ')[0] + ' ' + opt.NOMEPACIENTE.split(' ').slice(-1).join(' ') + ' / ' + opt.DESCRICAOITEM,
                                value: opt.CODIGOATENDIMENTO,
                                nome: opt.NOMEPACIENTE,
                                item: opt.CODIGOITEMPEDIDO

                              }))}
                            isClearable={true}
                            onFocus={opt => {
                              this.actionPause(0);
                            }}
                            onBlur={opt => {
                              this.actionPause(1);
                            }}
                            onChange={opt => {
                              if (opt !== null && opt !== '') {
                                const pessoa = this.state.searchPacientes.find((elem) => (elem.NOMEPACIENTE === opt.nome && elem.CODIGOATENDIMENTO === opt.value && elem.CODIGOITEMPEDIDO === opt.item));
                                if (pessoa) {
                                  this.setState({
                                    filteredPacientes: [pessoa]
                                  });
                                } else {
                                  this.setState({
                                    filteredPacientes: this.state.searchPacientes,
                                  });
                                }
                              } else {
                                this.setState({
                                  filteredPacientes: this.state.searchPacientes,
                                });
                              }
                            }}
                          />
                        </div>
                      </form>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeTheme()}><img src={"/img/icon_theme" + this.state.iconText + ".svg"} alt="" /></button>
                    </div>
                  </div>
                  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Leito</th>
                        <th>Paciente</th>
                        <th>Solicitante</th>
                        <th>Exame </th>
                        <th>Minutos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        (this.state.filteredPacientes.length === 1
                          ? this.state.filteredPacientes
                          : this.state.pacientes).map((data) => {
                            let key = data.CODIGOITEM + data.CODIGOITEMPEDIDO;
                            let status = "-";
                            let color = '';
                            let statusClass = "ready";
                            let tdClassRx = "";
                            let spanClassRx = "";
                            let tdClassFarm = "";
                            let spanClassFarm = "";
                            let name = data.NOMEPACIENTE.split(' ')[0] + ' ' + data.NOMEPACIENTE.split(' ').slice(-1).join(' ');
                            let solicitante = data.NOMEPRESTADOR.split(' ')[0] + ' ' + data.NOMEPRESTADOR.split(' ').slice(-1).join(' ');
                            if (data.TIPOATENDIMENTO === 'U') {
                              color = 'red';
                            }
                            if (data.COLETAREALIZADA) {
                              status = "Aguardando laudo";
                              tdClassRx = "attention";
                              spanClassRx = "success-circle";
                              statusClass = "ready";
                            } else {
                              status = "Aguardando coleta";
                              statusClass = "waiting";
                              //tdClassRx="attention";
                              //spanClassRx="attention-circle";
                            }

                            if (data.MINUTOSAGUARDANDO > 30) {
                              tdClassFarm = "attention";
                              spanClassFarm = "attention-circle";
                            } else {
                              spanClassFarm = "success-circle";
                            }

                            let time = data.MINUTOSAGUARDANDO;
                            if (data.MINUTOSAGUARDANDO > 60) {
                              var hours = (data.MINUTOSAGUARDANDO / 60);
                              var rhours = Math.floor(hours);
                              var minutes = (hours - rhours) * 60;
                              var rminutes = Math.round(minutes);
                              time = rhours + " hs " + rminutes + " mins";
                            } else {
                              time = time + ' mins';
                            }

                            return (
                              <tr key={key} className={statusClass}>
                                {/* <td><div className="alert-label"></div></td> */}
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left" className='alert-content'>
                                  <div className="alert-label" /><b>{status}</b></td>
                                <td style={{ color: color }} align="left"><b>{data.LEITO}</b></td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{name}</b>  ({data.CODIGOATENDIMENTO})</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{solicitante}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.DESCRICAOITEM}</td>
                                <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </table>
                </main>
                <InsightcareLocalFooter hospitalName={this.state.locationName} theme={theme} />
              </div>
            )
        }
      </div>
    );
  }
}

export default PainelLaboratorioFast;
